import { __assign } from "tslib";
import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Popup from '../../Popup';
import Logo from '@wix/da-ds/pkg/Logo';
import UserLink from '../../User/Link';
import withPopupArt from '../withPopupArt';
import s from './ArtBrandedMobilePopup.scss';
var ArtBrandedMobilePopup = function (_a) {
    var artImageSrc = _a.artImageSrc, artAuthor = _a.artAuthor, onClose = _a.onClose, _b = _a.popupProps, popupProps = _b === void 0 ? {} : _b, children = _a.children;
    var t = useTranslation().t;
    return (React.createElement(Popup, __assign({ className: s['modal'], onRequestClose: onClose }, popupProps),
        React.createElement("div", { className: s['root'], style: { backgroundImage: artImageSrc && "url(".concat(artImageSrc, ")") } },
            React.createElement("div", { className: s['inner'] },
                React.createElement(Logo, { size: "tiny", markColor: "white", textColor: "white" }),
                React.createElement("div", { className: s['content'] }, children),
                React.createElement("div", { className: classnames(s['artist-credit'], artAuthor && s['loaded']) }, artAuthor && (React.createElement(React.Fragment, null,
                    t('verification.artistCredit'),
                    ' ',
                    React.createElement(UserLink, { className: s['user-link'], user: artAuthor }))))))));
};
export default withPopupArt(ArtBrandedMobilePopup);
//# sourceMappingURL=ArtBrandedMobilePopup.js.map